import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { IBuyPackageHeldPayment } from '../../reducers/types';

export const SET_BUY_PACKAGE_HELD_PAYMENT = 'BUY_PACKAGE :: HELD_PAYMENT';

export type TSetBuyPackageHeldPayment = IReduxAction<typeof SET_BUY_PACKAGE_HELD_PAYMENT, IBuyPackageHeldPayment>;

export const setBuyPackageHeldPayment = actionGenerator<typeof SET_BUY_PACKAGE_HELD_PAYMENT, IBuyPackageHeldPayment>(
  SET_BUY_PACKAGE_HELD_PAYMENT,
);
